export default class AccidentInfo {
    constructor(
        {
            type = '',
            date = '',
            time = '',
            cost = '',
            partyAtFault = '',
            hadInjuries = '',
            hadActiveInsurance = 'No',
            location = '',
            description = '',
            weatherCondition = '',
            hadWitness = '',
           wasAccidentSettled = '',
        }
    ) {

        this.type = type;
        this.date = date;
        this.time = time;
        this.cost = cost;
        this.partyAtFault = partyAtFault;
        this.hadInjuries = hadInjuries;
        this.hadActiveInsurance = hadActiveInsurance;
        this.location = location;
        this.description = description;
        this.weatherCondition = weatherCondition;
        this.hadWitness = hadWitness;
        this.wasAccidentSettled = '';

    }
}